import React from "react";
import "./rewardSystem.css";

// SVG components
import { ReactComponent as Trophy } from "../../assets/icons/trophy.svg";

// Image
import WelcomeBoxes from "../../assets/images/WelcomeBox.png";
import XpReward from "../../assets/images/xpReward.png";
import VIP from "../../assets/images/vip.png";
import Raffle from "../../assets/images/raffle.png";
import { routes } from "../../routes";
import { useNavigate } from "react-router-dom";

// Rewards data
const rewards = [
  {
    icon: () => (
      <img
        style={{ width: "179px", maxWidth: "100%" }}
        src={WelcomeBoxes}
        alt="Welcome Boxes"
      />
    ),
    title: "Welcome Boxes",
    description:
      "Kick things off with free boxes and get a chance to win from the start.",
  },
  {
    icon: () => (
      <img style={{ width: "120px" }} src={Raffle} alt="Exclusive Raffles" />
    ),
    title: "Exclusive Raffles",
    description: "Enter raffles and compete for high-value prizes.",
  },
  {
    icon: () => (
      <img style={{ width: "120px" }} src={XpReward} alt="XP Rewards" />
    ),
    title: "XP Rewards",
    description:
      "Earn XPs as you play and use them to unlock more opportunities.",
  },
  {
    icon: () => <img style={{ width: "120px" }} src={VIP} alt="VIP Perks" />,
    title: "Bonuses & VIP Perks",
    description:
      "Unlock exclusive offers, rewards, and perks as you stay active.",
  },
];

const RewardSystem = () => {
  const navigate = useNavigate();
  return (
    <div className="reward-system container-fluid">
      {/* Header */}
      <div className="reward-system__header">
        <span className="reward-system__trophy">
          <Trophy />
        </span>
        <h2 className="reward-system__title">Best Reward System</h2>
      </div>

      {/* Cards Grid */}
      <div className="reward-system__grid">
        {rewards.map((reward, index) => {
          const Icon = reward.icon;

          return (
            <div className="reward-card" key={index}>
              <div className="reward-card__icon-wrapper">
                <span className="reward-card__icon">
                  <Icon />
                </span>
              </div>

              <h3 className="reward-card__title">{reward.title}</h3>

              <p className="reward-card__description">{reward.description}</p>
            </div>
          );
        })}
      </div>

      {/* CTA Button */}
      <div className="d-center">
        <button
          onClick={() => navigate(routes.COMINGSOON)}
          className="reward-system__cta-btn"
        >
          Claim Your Rewards
          <span>
            <svg
              style={{ marginBottom: "3px" }}
              width="12"
              height="12"
              viewBox="0 0 24 24"
              fill="none"
              stroke="black"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="6 4 14 12 6 20" />
              <polyline points="12 4 20 12 12 20" />
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
};

export default RewardSystem;
